import styled from "styled-components";
import { color } from "../../../shared/styles";

export const SingleMaterialContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

export const ContentWrapper = styled.div`
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    border-radius: 20px;
    background-color: ${color.emphasis.NEUTRAL_N0};
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
    height: auto;
`;

export const InfoBoxWrapper = styled.div`
    background-color: white;
    border-radius: 5px;
    min-height: fit-content;
    border: 1px solid ${color.secondary.BORDER};
    box-shadow: none;
    height: auto;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .text {
        font-family: Noto Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
`;

export const InfoBoxTitle = styled.div`
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
`;

export const SaleOrderTableText = styled.div`
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    border-left: 5px solid var(--Primary-Blue-B100, #0058a0);
    padding-left: 15px;
`;
export const SaleOrderLinkedWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
export const SaleOrderChildLinkedWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
`;
export const SaleOrderLinkedTitle = styled.div`
    color: #333739;
    text-align: left;
    font-family: "Noto Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 150% */
`;

export const QuantityBubble = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    background-color: #f0f2f5;
    color: #333739;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    margin-left: 6px;
`;